// extracted by mini-css-extract-plugin
module.exports = {"Text":"ResizableTextarea_Text__2rN6L"};